module.exports = __webpack_public_path__ + "img/mntn_02.0be67ca1.svg";